<template>
  <div>
    <div class="flex justify-between flex-nowrap pb-2 border-base-30 border-b p-4">
      <div>
        <div class="content-slide__type">
          Content
        </div>
        <div class="font-bold flex">
          <p
            v-html="freestyleHeading"
            class="content-slide__heading"
            :class="{'text-base': isModalContent}"
          ></p>
        </div>
      </div>
      <div class="flex-shrink-0 pl-7">
        <aha-antd-button
          @click="handleAddSlideToPresentation(response)"
          :submitting="response.isAddingSlide"
          :disabled="response.isDisabled || response.isAddingSlide"
          v-aha-emit-action="{ user_input: 'Content' }"
          name="ai_generated_freestyle_add_button"
        >
          {{ $i18nPresenter.t('Add') }}
        </aha-antd-button>
      </div>
    </div>
    <div v-html="freestyleContent" class="p-4 text-sm"></div>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
    isModalContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    freestyleHeading() {
      const hasResponse = this.response && this.response.data &&
      this.response.data[0] && this.response.data[0].content && this.response.data[0].content.value
      if (hasResponse) {
        return this.response.data[0].content.value
      }
      return this.response.content.data[0].content.value
    },
    freestyleContent() {
      if (this.response.data && this.response.data[1].content.value) {
        return this.response.data[1].content.value
      }
      return this.response.content.data[1].content.value
    },
  },
  methods: {
    handleAddSlideToPresentation(response) {
      this.$emit('handleAddSlideToPresentation', response)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-slide__type {
  background-color: #EFF1F7; // secondary-15
  width: max-content;
  font-size: 12px;
  border-radius: 20px;
  padding: 0 0.5rem;
  color: #3F4557; // secondary-60
  margin-bottom: 0.5rem;
}
.content-slide__heading {
  &::v-deep p {
    font-size: 14px !important;
  }
  &.text-base::v-deep p {
    font-size: 14px !important;
  }
}
</style>
